module.exports = __webpack_public_path__ + "static/media/movies.44a77709.png";